import { useQuery } from '@tanstack/react-query';

import { api, queryString } from '@/lib/api';
import type { AnalyticsOverview } from '@shared/schemas/analytics';

/* The query behind /admin/analytics. Owner ask, 2026-08-10. */

/**
 * One request for the whole screen.
 *
 * **Not split into a query per panel.** Nothing on this screen changes without
 * the rest of it changing: the only control is the month range, and that moves
 * the revenue chart. Four hooks would mean four cache entries to keep in step
 * and four entries in the budget `request-budget.spec.ts` polices, to save
 * re-reading three cheap aggregates.
 */
export function useAnalytics(months: number) {
  return useQuery({
    queryKey: ['admin', 'analytics', months],
    queryFn: () => api.get<AnalyticsOverview>(`/api/admin/analytics${queryString({ months })}`),
    placeholderData: (previous) => previous,
  });
}
